import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLeftMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 88,
	viewBox: "0 0 21 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4408 80.013L14.4408 82.2768L20.6313 82.2768L20.6313 87.3L0.5 87.3L0.5 79.1817C0.5 77.5736 0.803785 76.1763 1.40765 74.9937C2.01152 73.811 2.87471 72.8977 3.99724 72.2537C5.11976 71.6097 6.43863 71.2896 7.95386 71.2896C9.46908 71.2896 10.6805 71.5902 11.766 72.1913C12.8478 72.7923 13.6961 73.651 14.3111 74.7673L20.6387 70.9345L20.6387 76.3129L14.4482 80.013L14.4408 80.013ZM5.17163 78.9241L5.17163 82.0738L9.51353 82.0738L9.51353 78.9241C9.51353 77.6595 8.5429 76.6369 7.34258 76.6369C6.14226 76.6369 5.17163 77.6595 5.17163 78.9241Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4146 55.8921L20.635 55.8921L20.635 60.9153L13.3294 60.9153L0.5 67.691L0.5 62.3868L8.49474 58.1753L0.499999 53.9639L0.499999 49.0929L13.4146 55.8921Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2339 9.6991L20.635 9.6991L20.635 23.9609L0.5 23.9609L0.499999 10.0309L4.90118 10.0309L4.90118 18.9884L8.29469 18.9884L8.29469 11.0964L12.5514 11.0964L12.5514 18.9884L16.2339 18.9884L16.2339 9.70301L16.2339 9.6991Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6351 28.9647L20.6351 37.3642C20.6351 39.3079 20.2238 41.033 19.3977 42.5396C18.5753 44.0462 17.4046 45.2132 15.8893 46.0407C14.3741 46.8681 12.5996 47.2858 10.5694 47.2858C8.53922 47.2858 6.76467 46.872 5.24944 46.0407C3.73422 45.2132 2.56354 44.0462 1.74109 42.5396C0.918649 41.033 0.503723 39.3079 0.503723 37.3642L0.503722 28.9647L20.6351 28.9647ZM16.0894 33.988L5.04569 33.988L5.04569 37.1612C5.04569 38.6834 5.53471 39.9051 6.51275 40.8262C7.49079 41.7473 8.843 42.2079 10.5694 42.2079C12.2958 42.2079 13.648 41.7473 14.626 40.8262C15.6041 39.9051 16.0931 38.6834 16.0931 37.1612L16.0931 33.988L16.0894 33.988Z",
			fill: "#40E099"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.693 0.0273514L15.693 4.5354L20.6313 4.5354L20.6313 0.0273512L15.693 0.0273514Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoLeftMui);
export { ForwardRef as ReactComponent };
